import { useEffect, useState } from 'react';
import { DEFAULT_CUISINE_OPTIONS } from '../components/menuPreferencesConstants';

/**
 * Cuisine options that match what the menu browser actually offers.
 *
 * The list is derived from approved public recipes, so preference pickers and
 * menu filters can never drift apart. DEFAULT_CUISINE_OPTIONS is only a
 * placeholder while the request is in flight or if it fails.
 */
export default function useCuisineOptions() {
  const [cuisines, setCuisines] = useState(DEFAULT_CUISINE_OPTIONS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/menu/cuisines`);
        if (!response.ok) throw new Error('Failed to load cuisines');
        const data = await response.json();
        const list = (data.cuisines || []).filter(Boolean);
        if (!cancelled && list.length) setCuisines(list);
      } catch (error) {
        // Keep the fallback list rather than showing an empty picker.
        console.error('Error loading cuisine options:', error);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => { cancelled = true; };
  }, []);

  return { cuisines, loading };
}
